const Modal = ({ children, width="50%" }) => {

    return (
        <div className="w-screen overflow-y-auto h-screen fixed top-0 left-0 bg-[rgb(0,0,0,0.7)] z-10">
            <div className="h-fit overflow-y-auto m-auto mt-4 p-2 bg-black border border-[#d59106]" style={{width}} onClick={(e) => e.stopPropagation()}>
                {children}
            </div>
        </div>
    )
}

export default Modal;